import React, { createContext, useState, useContext } from 'react';

// Cria um contexto para destacar geometrias
const GeometryHighlightContext = createContext();

// Provider do contexto de highlight de geometrias
export function GeometryHighlightProvider({ children }) {
  // Estado para armazenar a geometria a ser destacada
  const [highlightedGeometry, setHighlightedGeometry] = useState(null);
  // Estado para rastrear o contador de flash (usado para piscar)
  const [flashCounter, setFlashCounter] = useState(0);

  // Função para destacar uma geometria com efeito de flash
  const highlightGeometryWithFlash = (domain, id, geometry) => {
    // Define a geometria a ser destacada
    setHighlightedGeometry({
      domain,
      id,
      geometry,
      timestamp: Date.now(), // Timestamp para forçar reações em componentes observadores
      highlight: true,
    });

    // Sequência para piscar 2 vezes:
    // 1. Mostrar inicialmente
    setFlashCounter((prev) => prev + 1);

    // 2. Esconder após 300ms
    setTimeout(() => {
      setHighlightedGeometry((prev) => ({
        ...prev,
        highlight: false,
        timestamp: Date.now(),
      }));

      // 3. Mostrar novamente após mais 300ms
      setTimeout(() => {
        setHighlightedGeometry((prev) => ({
          ...prev,
          highlight: true,
          timestamp: Date.now(),
        }));

        // 4. Estado final permanente após mais 300ms
        setTimeout(() => {
          setHighlightedGeometry((prev) => ({
            ...prev,
            highlight: true,
            permanent: true,
            timestamp: Date.now(),
          }));
        }, 300);
      }, 300);
    }, 300);
  };

  // Limpa o estado de destaque
  const clearHighlight = () => {
    setHighlightedGeometry(null);
  };

  // Valor do contexto que será disponibilizado para os componentes
  const contextValue = {
    highlightedGeometry,
    flashCounter,
    highlightGeometryWithFlash,
    clearHighlight,
  };

  return (
    <GeometryHighlightContext.Provider value={contextValue}>
      {children}
    </GeometryHighlightContext.Provider>
  );
}

// Hook personalizado para usar o contexto
// eslint-disable-next-line react-refresh/only-export-components
export function useGeometryHighlight() {
  const context = useContext(GeometryHighlightContext);
  if (!context) {
    throw new Error('useGeometryHighlight deve ser usado dentro de um GeometryHighlightProvider');
  }
  return context;
}
